import { render, staticRenderFns } from "./V3Icon.vue?vue&type=template&id=bfe1ea22"
import script from "./V3Icon.vue?vue&type=script&setup=true&lang=ts"
export * from "./V3Icon.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports